module.exports = __webpack_public_path__ + "img/bandcamp-logotype-light-128.3df82a1b.png";